import { useState } from "react";
// import { initialOutlet, Outlet } from '../core/_models'
import { useQueryResponse } from "../core/QueryResponseProvider";
import { Modal, Button, Table } from 'react-bootstrap'
import * as XLSX from 'xlsx';
import moment from "moment";
interface Column {
  label: string;
  data: string[];
}

const DealerUpload = ({close}:any) => {
  const [fileName, setFileName] = useState(null)
  const [columns, setColumns] = useState<Column[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [duplicateRows, setDuplicateRows] = useState<any[]>([]);
  const [myData, setMyData] = useState<any[]>([]);

  const fileUpload = (e: any) => {
    setFileName(e.target.files[0]);
    //console.log("file ...............",fileName);
  };

  
  // console.log("file ...............",fileName);
  const closeModal = () => {
    setShowModal(false);
  };



  const formSubmit = async () => {
    // Check if any file is selected or not
    const ADMIN_API_URL = process.env.REACT_APP_API_URL
    if (fileName != null) {
      const data = new FormData();
      data.append('mtp_file', fileName);
      //console.log("append ...............",fileName);  
      let res = await fetch(
        `${ADMIN_API_URL}/master/dealer/uploadDealerExcel`,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: 'post',
          body: JSON.stringify({data:myData}),
        }
      );

      // console.log(res);
      let responseJson = await res.json();
      if (responseJson.error == false) {
        alert('Upload Successful');
        setFileName(null);
        close();
        // window.location.reload();
      } else {
        alert(responseJson.message);
        setFileName(null);
      }
    } else {
      // If no file selected the show alert
      alert('Please Select File first');
    }
  };

  const checkData = () => {
    setShowModal(true);
    const file = fileName;

    if (!file) {
      // Handle case when no file is selected
      return;
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: 'array', cellDates: true, dateNF: 'yyyy-mm-dd' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData: any[] = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false });

      if (!isValidFormat(jsonData)) {
        alert('Invalid Excel file format');
        return;
      }
      //  console.log(jsonData);
      const duplicateRows: any[] = [];
      const rowSet = new Set<string>();

      for (let rowIndex = 1; rowIndex < jsonData.length; rowIndex++) {
        const row = JSON.stringify(jsonData[rowIndex]);
        // console.log(row);
        if (rowSet.has(row)) {
          duplicateRows.push(jsonData[rowIndex]);
        }
        rowSet.add(row);
      }
      var data1: any[] = [];
      if (duplicateRows.length > 0) {
        setDuplicateRows(duplicateRows);
      } else {
        const newColumns: Column[] = [];


        if (jsonData.length > 0) {
          const headers: string[] = jsonData[0];

          for (let colIndex = 0; colIndex < headers.length; colIndex++) {
            const columnData: string[] = [];

            for (let rowIndex = 1; rowIndex < jsonData.length; rowIndex++) {
              const cellValue = jsonData[rowIndex][colIndex] || '';
              columnData.push(cellValue);
            }
            newColumns.push({
              label: headers[colIndex],
              data: columnData,
            });
          }

          for (let rowIndex = 1; rowIndex < jsonData.length; rowIndex++) {
            data1.push({
              warehouse_id: jsonData[rowIndex][0] || '',
              dealer_name: jsonData[rowIndex][1] || '',
              zone_id: jsonData[rowIndex][2] || '',
              erp_id: jsonData[rowIndex][3] || '',
              address: jsonData[rowIndex][4] || '',
              phone_number: jsonData[rowIndex][5] || '',
              email: jsonData[rowIndex][6] || '',
              tax_number: jsonData[rowIndex][7] || '',
              is_distributor: jsonData[rowIndex][8] || '',
              state_id: jsonData[rowIndex][9] || '',
              city_id: jsonData[rowIndex][10] || '',
              district_id: jsonData[rowIndex][11] || '',
              distributor_warehouse_id: jsonData[rowIndex][12] || '',
              default_credit_limit: jsonData[rowIndex][13] || '',
              gst_in_number: jsonData[rowIndex][14] || '',
              license_number: jsonData[rowIndex][15] || '',
              division_id: jsonData[rowIndex][16] || '',
              status: jsonData[rowIndex][17] || '',
              enter_by: jsonData[rowIndex][18] || '',
              enter_date: moment().format("YYYY/MM/DD HH:mm:ss"),
            })
            // console.log(data1);
          }
          setMyData(data1);
        }
        setColumns(newColumns);
      }
    }
    reader.readAsArrayBuffer(file);
    console.log("mydata s", myData);
  }

  const isValidFormat = (jsonData: any[]): boolean => {

    // Check if the required format conditions are met
    // For example, ensure a minimum number of columns or specific column headers are present
    // Return true if the format is valid, false otherwise
    // You can customize this function based on your specific Excel file format requirements
    // return true;

    if (jsonData.length <= 1) {
      return false;
    }

    // Check if the first row contains column headers
    const headers: any[] = jsonData[0];

    if (!headers.every((header) => typeof header === 'string')) {
      return false;
    }

    // Check if there are at least two columns
    if (headers.length != 20) {
      return false;
    }

    // You can add more specific format checks here, such as column data types, required columns, etc.

    return true;
  };

  return (
    <>
      {/* <UploadHeader /> */}

      <div className='d-flex justify-content-end' data-kt-outlet-table-toolbar='base'>
        {/* accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet application/vnd.ms-excel" */}
        <input type="file" name="image" onChange={fileUpload} accept=".xls,.xlsx" />
        {/* <input type="button" className="btn btn-primary" value="Submit" onClick={formSubmit} /> */}
        <input type="button" className="btn btn-primary" value="Submit" onClick={checkData} />


      </div>
      <div>
      <Modal show={showModal} onHide={closeModal} centered size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Outlet Upload Data</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {duplicateRows.length > 0 && (
      <div className="mb-3">
        <h5>Duplicate Rows:</h5>
      </div>
    )}
    {duplicateRows.length > 0 ? (
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.label}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {duplicateRows.map((row: any[], rowIndex: number) => (
              <tr key={rowIndex}>
                {row.map((cell: any, cellIndex: number) => (
                  <td key={`${rowIndex}-${cellIndex}`}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      columns.length > 0 && (
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.label}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {columns[0].data.map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((column) => (
                    <td key={`${column.label}-${rowIndex}`}>
                      {column.data && column.data[rowIndex]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={closeModal}>
      Close
    </Button>
    <Button variant="primary" onClick={formSubmit} disabled={duplicateRows.length > 0}>
      Confirm
    </Button>
  </Modal.Footer>
</Modal>

      </div>

    </>

  )

}

export { DealerUpload }